import { useState, useEffect, useRef } from "react";

// ─── IPInfo Service (inline) ────────────────────────────────────────────────
class IPInfoService {
  constructor() {
    this.apiToken = "27f655aff05e14";
    this.baseURL = "https://ipinfo.io";
    this.ipData = null;
    this.initialized = false;
  }
  async init() {
    if (this.initialized) return this.ipData;
    try {
      const response = await fetch(
        `${this.baseURL}/json?token=${this.apiToken}`
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      this.ipData = await response.json();
      this.initialized = true;
      return this.ipData;
    } catch (error) {
      console.error("IPInfo Service Error:", error);
      throw error;
    }
  }
  getLocationForAds() {
    if (!this.initialized || !this.ipData)
      return { city: "", state: "", country: "global", zipcode: "" };
    return {
      city: this.ipData.city || "",
      state: this.ipData.region || "",
      country: this.ipData.country || "",
      zipcode: this.ipData.postal || "",
      timezone: this.ipData.timezone || "",
      ip: this.ipData.ip || "",
      location: this.ipData.loc || "",
    };
  }
}
const ipInfoService = new IPInfoService();

// ─── Sample Events Data ──────────────────────────────────────────────────────
const EVENTS_DATA = [
  {
    id: 1,
    title: "Global AI Summit 2025",
    category: "Technology",
    date: "2025-09-15",
    time: "10:00 AM",
    venue: "Online / Worldwide",
    description:
      "The world's largest AI conference, streamed globally. Connect with 50,000+ AI practitioners, researchers, and founders.",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80",
    price: "Free",
    tags: ["AI", "Technology", "Networking"],
    location: { country: "global" },
    featured: true,
  },
  {
    id: 2,
    title: "Bengaluru Tech Fest",
    category: "Technology",
    date: "2025-10-04",
    time: "9:00 AM",
    venue: "Bangalore International Exhibition Centre",
    description:
      "India's premier technology festival celebrating innovation, startups, and the next generation of builders from across the country.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80",
    price: "₹499",
    tags: ["Startups", "India", "Innovation"],
    location: { country: "IN", state: "Karnataka", city: "Bengaluru" },
    featured: true,
  },
  {
    id: 3,
    title: "Chennai Design Week",
    category: "Design",
    date: "2025-11-01",
    time: "11:00 AM",
    venue: "YMCA Grounds, Nandanam",
    description:
      "A week-long celebration of design culture in Chennai — from typography and branding to product design and UX.",
    image:
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&q=80",
    price: "₹299",
    tags: ["Design", "Branding", "UX"],
    location: { country: "IN", state: "Tamil Nadu", city: "Chennai" },
  },
  {
    id: 4,
    title: "Coimbatore Startup Mela",
    category: "Business",
    date: "2025-09-28",
    time: "10:00 AM",
    venue: "CODISSIA Trade Fair Complex",
    description:
      "A massive startup ecosystem event for founders, investors, and enthusiasts in the Tier-2 city revolution.",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&q=80",
    price: "₹199",
    tags: ["Startups", "Funding", "Networking"],
    location: {
      country: "IN",
      state: "Tamil Nadu",
      city: "Coimbatore",
      zipcode: "641014",
    },
  },
  {
    id: 5,
    title: "Erode Textile & Fashion Expo",
    category: "Fashion",
    date: "2025-10-18",
    time: "9:00 AM",
    venue: "Erode Town Hall, Brough Road",
    description:
      "Celebrating the textile capital of Tamil Nadu. Explore fabric innovations, handloom traditions, and sustainable fashion trends.",
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
    price: "Free",
    tags: ["Textile", "Fashion", "Culture"],
    location: {
      country: "IN",
      state: "Tamil Nadu",
      city: "Erode",
      zipcode: "638001",
    },
    featured: true,
  },
  {
    id: 6,
    title: "Silicon Valley Web3 Conference",
    category: "Technology",
    date: "2025-10-22",
    time: "9:00 AM",
    venue: "Moscone Center, San Francisco",
    description:
      "The definitive Web3 conference in the heart of Silicon Valley. DeFi, NFTs, blockchain infrastructure, and the decentralized future.",
    image:
      "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&q=80",
    price: "$299",
    tags: ["Web3", "Blockchain", "DeFi"],
    location: { country: "US", state: "California", city: "San Francisco" },
  },
  {
    id: 7,
    title: "Mumbai Film & Creative Arts Festival",
    category: "Arts",
    date: "2025-12-05",
    time: "6:00 PM",
    venue: "National Centre for the Performing Arts",
    description:
      "Three days of film screenings, creative workshops, and artist talks celebrating Indian cinema and contemporary art.",
    image:
      "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=600&q=80",
    price: "₹599",
    tags: ["Film", "Arts", "Culture"],
    location: { country: "IN", state: "Maharashtra", city: "Mumbai" },
  },
  {
    id: 8,
    title: "Global Climate Action Summit",
    category: "Environment",
    date: "2025-11-15",
    time: "8:00 AM",
    venue: "Virtual Event — Worldwide",
    description:
      "World leaders, scientists, and activists unite for 48 hours of live sessions on climate solutions and sustainability.",
    image:
      "https://images.unsplash.com/photo-1569163139599-0f4517e36f51?w=600&q=80",
    price: "Free",
    tags: ["Climate", "Sustainability", "Global"],
    location: { country: "global" },
    featured: true,
  },
  {
    id: 9,
    title: "Delhi Food & Culture Carnival",
    category: "Food",
    date: "2025-10-10",
    time: "12:00 PM",
    venue: "Jawaharlal Nehru Stadium Grounds",
    description:
      "500+ food stalls, live folk performances, and cultural experiences from every corner of India — all in Old Delhi.",
    image:
      "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80",
    price: "₹150",
    tags: ["Food", "Culture", "Festival"],
    location: { country: "IN", state: "Delhi", city: "New Delhi" },
  },
  {
    id: 10,
    title: "New York Product Design Week",
    category: "Design",
    date: "2025-11-03",
    time: "10:00 AM",
    venue: "Brooklyn Navy Yard",
    description:
      "NYC's premier product design event — furniture, industrial design, digital products, and everything in between.",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&q=80",
    price: "$149",
    tags: ["Design", "Product", "NYC"],
    location: { country: "US", state: "New York", city: "New York" },
  },
  {
    id: 11,
    title: "Hyderabad Biryani & Food Fest",
    category: "Food",
    date: "2025-09-20",
    time: "11:00 AM",
    venue: "Hitex Exhibition Centre",
    description:
      "Celebrating the iconic culinary culture of Hyderabad with 200+ restaurants, live cooking shows, and a biryani cook-off.",
    image:
      "https://images.unsplash.com/photo-1563245372-f21724e3856d?w=600&q=80",
    price: "₹99",
    tags: ["Food", "Festival", "Hyderabad"],
    location: { country: "IN", state: "Telangana", city: "Hyderabad" },
  },
  {
    id: 12,
    title: "Open Source Dev Conference",
    category: "Technology",
    date: "2025-12-12",
    time: "9:00 AM",
    venue: "Online — Global",
    description:
      "24 hours of talks, hackathons, and workshops celebrating the open source community and the future of collaborative software.",
    image:
      "https://images.unsplash.com/photo-1607705703571-c5a8695f18f6?w=600&q=80",
    price: "Free",
    tags: ["Open Source", "Dev", "Hackathon"],
    location: { country: "global" },
  },
];

// ─── Country code → name map ──────────────────────────────────────────────
const COUNTRY_NAMES = {
  IN: "India",
  US: "United States",
  GB: "United Kingdom",
  global: "Global",
};

// ─── Location matching logic ──────────────────────────────────────────────
function matchesLocation(event, userLoc) {
  const evLoc = event.location;
  if (!evLoc || evLoc.country === "global") return true;

  // Country must match (compare ISO codes, case-insensitive)
  const evCountry = evLoc.country?.toUpperCase();
  const userCountry = userLoc.country?.toUpperCase();
  if (evCountry !== userCountry) return false;

  // If event specifies zipcode → match zipcode
  if (evLoc.zipcode) return evLoc.zipcode === userLoc.zipcode;

  // If event specifies city → match city (case-insensitive)
  if (evLoc.city)
    return evLoc.city.toLowerCase() === userLoc.city?.toLowerCase();

  // If event specifies state → match state
  if (evLoc.state)
    return evLoc.state.toLowerCase() === userLoc.state?.toLowerCase();

  // Country-level match
  return true;
}

// ─── Category colours ─────────────────────────────────────────────────────
const CATEGORY_STYLES = {
  Technology: { bg: "#0ff2fe22", accent: "#0ff2fe", label: "Technology" },
  Design: { bg: "#f953c622", accent: "#f953c6", label: "Design" },
  Business: { bg: "#43e97b22", accent: "#43e97b", label: "Business" },
  Fashion: { bg: "#fa709a22", accent: "#fa709a", label: "Fashion" },
  Arts: { bg: "#f7971e22", accent: "#f7971e", label: "Arts" },
  Environment: { bg: "#11998e22", accent: "#11998e", label: "Environment" },
  Food: { bg: "#f6d36522", accent: "#f6d365", label: "Food" },
};

// ─── Utility ──────────────────────────────────────────────────────────────
const fmt = (d) =>
  new Date(d).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

// ─── Sub-components ───────────────────────────────────────────────────────
function LocationBadge({ userLoc, loading }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 40,
        padding: "8px 16px",
        fontSize: 13,
        color: "#ccc",
        backdropFilter: "blur(8px)",
      }}
    >
      <span style={{ fontSize: 16 }}>📍</span>
      {loading ? (
        <span style={{ color: "#888" }}>Detecting location…</span>
      ) : userLoc ? (
        <span>
          {[
            userLoc.city,
            userLoc.state,
            COUNTRY_NAMES[userLoc.country] || userLoc.country,
          ]
            .filter(Boolean)
            .join(", ")}
        </span>
      ) : (
        <span style={{ color: "#888" }}>
          Location unavailable — showing all events
        </span>
      )}
    </div>
  );
}

function CategoryPill({ category }) {
  const s = CATEGORY_STYLES[category] || {
    bg: "#ffffff18",
    accent: "#fff",
    label: category,
  };
  return (
    <span
      style={{
        background: s.bg,
        color: s.accent,
        border: `1px solid ${s.accent}44`,
        borderRadius: 20,
        padding: "3px 10px",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1,
        textTransform: "uppercase",
      }}
    >
      {s.label}
    </span>
  );
}

function ScopeTag({ event, userLoc }) {
  const loc = event.location;
  let label = "🌍 Global";
  let color = "#a0f0a0";
  if (loc?.country && loc.country !== "global") {
    if (loc.zipcode) {
      label = `📮 ${loc.zipcode}`;
      color = "#f9c74f";
    } else if (loc.city) {
      label = `🏙 ${loc.city}`;
      color = "#90e0ef";
    } else if (loc.state) {
      label = `🗺 ${loc.state}`;
      color = "#c77dff";
    } else {
      label = `🏳 ${COUNTRY_NAMES[loc.country] || loc.country}`;
      color = "#f4a261";
    }
  }
  return (
    <span style={{ fontSize: 11, color, fontWeight: 600, opacity: 0.85 }}>
      {label}
    </span>
  );
}

function EventCard({ event, userLoc, index }) {
  const [hovered, setHovered] = useState(false);
  const cat = CATEGORY_STYLES[event.category] || { accent: "#fff" };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        borderRadius: 20,
        overflow: "hidden",
        background: "rgba(255,255,255,0.035)",
        border: `1px solid ${
          hovered ? cat.accent + "66" : "rgba(255,255,255,0.08)"
        }`,
        transition: "all 0.35s cubic-bezier(.22,.68,0,1.2)",
        transform: hovered ? "translateY(-6px) scale(1.012)" : "none",
        boxShadow: hovered
          ? `0 24px 60px ${cat.accent}22`
          : "0 4px 20px rgba(0,0,0,0.3)",
        display: "flex",
        flexDirection: "column",
        animationDelay: `${index * 60}ms`,
        animation: "fadeUp 0.5s ease both",
        cursor: "pointer",
      }}
    >
      {/* Image */}
      <div style={{ position: "relative", height: 190, overflow: "hidden" }}>
        <img
          src={event.image}
          alt={event.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.5s ease",
            transform: hovered ? "scale(1.07)" : "scale(1)",
          }}
          loading="lazy"
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(8,8,18,0.9) 0%, transparent 50%)",
          }}
        />
        {event.featured && (
          <div
            style={{
              position: "absolute",
              top: 12,
              right: 12,
              background: "linear-gradient(135deg, #f6d365, #fda085)",
              color: "#1a0a00",
              fontSize: 10,
              fontWeight: 800,
              padding: "4px 10px",
              borderRadius: 20,
              letterSpacing: 1,
              textTransform: "uppercase",
            }}
          >
            ⭐ Featured
          </div>
        )}
        <div
          style={{
            position: "absolute",
            bottom: 10,
            left: 12,
            right: 12,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <CategoryPill category={event.category} />
          <ScopeTag event={event} userLoc={userLoc} />
        </div>
      </div>

      {/* Content */}
      <div
        style={{
          padding: "18px 20px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          flex: 1,
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: 17,
            fontWeight: 700,
            color: "#f0f0f5",
            lineHeight: 1.35,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          {event.title}
        </h3>

        <p
          style={{
            margin: 0,
            fontSize: 13,
            color: "#999",
            lineHeight: 1.6,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {event.description}
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            marginTop: 4,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              fontSize: 12,
              color: "#aaa",
            }}
          >
            <span>📅</span>
            <span>{fmt(event.date)}</span>
            <span style={{ opacity: 0.4 }}>•</span>
            <span>🕐</span>
            <span>{event.time}</span>
          </div>
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              fontSize: 12,
              color: "#aaa",
            }}
          >
            <span>📍</span>
            <span
              style={{
                flex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {event.venue}
            </span>
          </div>
        </div>

        <div
          style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 2 }}
        >
          {event.tags.map((t) => (
            <span
              key={t}
              style={{
                background: "rgba(255,255,255,0.07)",
                color: "#bbb",
                borderRadius: 12,
                padding: "2px 9px",
                fontSize: 11,
              }}
            >
              #{t}
            </span>
          ))}
        </div>

        <div
          style={{
            marginTop: "auto",
            paddingTop: 14,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTop: "1px solid rgba(255,255,255,0.07)",
          }}
        >
          <span
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 18,
              fontWeight: 700,
              color: event.price === "Free" ? "#43e97b" : "#f6d365",
            }}
          >
            {event.price}
          </span>
          <button
            style={{
              background: `linear-gradient(135deg, ${cat.accent}cc, ${cat.accent}88)`,
              border: "none",
              color: "#fff",
              padding: "8px 18px",
              borderRadius: 30,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              letterSpacing: 0.5,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 0.8)}
            onMouseLeave={(e) => (e.target.style.opacity = 1)}
          >
            Register →
          </button>
        </div>
      </div>
    </div>
  );
}

function FilterBar({ active, setActive, categories }) {
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      {["All", ...categories].map((cat) => {
        const s = CATEGORY_STYLES[cat];
        const isActive = active === cat;
        return (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            style={{
              background: isActive
                ? s
                  ? s.accent
                  : "#fff"
                : "rgba(255,255,255,0.06)",
              color: isActive ? "#0a0a14" : "#aaa",
              border: isActive ? "none" : "1px solid rgba(255,255,255,0.12)",
              borderRadius: 30,
              padding: "7px 16px",
              fontSize: 13,
              fontWeight: isActive ? 700 : 500,
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            {cat}
          </button>
        );
      })}
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────
export default function EventsPage() {
  const [userLoc, setUserLoc] = useState(null);
  const [locLoading, setLocLoading] = useState(true);
  const [locError, setLocError] = useState(false);
  const [activeCategory, setActiveCategory] = useState("All");
  const [search, setSearch] = useState("");
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await ipInfoService.init();
        setUserLoc(ipInfoService.getLocationForAds());
      } catch {
        setLocError(true);
      } finally {
        setLocLoading(false);
      }
    })();
  }, []);

  const allCategories = [...new Set(EVENTS_DATA.map((e) => e.category))];

  const filtered = EVENTS_DATA.filter((event) => {
    const locMatch =
      locError || !userLoc || showAll ? true : matchesLocation(event, userLoc);
    const catMatch =
      activeCategory === "All" || event.category === activeCategory;
    const searchMatch =
      !search ||
      event.title.toLowerCase().includes(search.toLowerCase()) ||
      event.description.toLowerCase().includes(search.toLowerCase()) ||
      event.tags.some((t) => t.toLowerCase().includes(search.toLowerCase()));
    return locMatch && catMatch && searchMatch;
  });

  const hiddenCount = showAll
    ? 0
    : EVENTS_DATA.filter((e) => !matchesLocation(e, userLoc || {})).length;

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #070714 0%, #0d0d1f 40%, #0a0a18 100%)",
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        color: "#f0f0f5",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
        @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
        @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #0a0a18; }
        ::-webkit-scrollbar-thumb { background: #333; border-radius: 3px; }
        input::placeholder { color: #555; }
      `}</style>

      {/* Hero Header */}
      <div
        style={{
          padding: "60px 40px 40px",
          maxWidth: 1280,
          margin: "0 auto",
          position: "relative",
        }}
      >
        {/* Decorative glow */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 600,
            height: 300,
            background:
              "radial-gradient(ellipse, rgba(100,80,255,0.15) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 16,
              marginBottom: 28,
            }}
          >
            <div>
              <p
                style={{
                  margin: "0 0 8px",
                  fontSize: 12,
                  letterSpacing: 4,
                  color: "#7c6fff",
                  textTransform: "uppercase",
                  fontWeight: 700,
                }}
              >
                Discover Events
              </p>
              <h1
                style={{
                  margin: 0,
                  fontSize: "clamp(36px, 5vw, 58px)",
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 800,
                  lineHeight: 1.1,
                  background: "linear-gradient(135deg, #fff 0%, #a78bfa 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Events Near You
              </h1>
            </div>
            <LocationBadge userLoc={userLoc} loading={locLoading} />
          </div>

          {/* Search */}
          <div
            style={{ position: "relative", maxWidth: 480, marginBottom: 24 }}
          >
            <span
              style={{
                position: "absolute",
                left: 16,
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: 16,
                opacity: 0.5,
              }}
            >
              🔍
            </span>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search events, tags, topics…"
              style={{
                width: "100%",
                padding: "12px 16px 12px 44px",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 40,
                color: "#fff",
                fontSize: 14,
                outline: "none",
                transition: "border 0.2s",
              }}
              onFocus={(e) =>
                (e.target.style.borderColor = "rgba(124,111,255,0.6)")
              }
              onBlur={(e) =>
                (e.target.style.borderColor = "rgba(255,255,255,0.1)")
              }
            />
          </div>

          {/* Filters */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <FilterBar
              active={activeCategory}
              setActive={setActiveCategory}
              categories={allCategories}
            />

            {!locError && userLoc && hiddenCount > 0 && !showAll && (
              <button
                onClick={() => setShowAll(true)}
                style={{
                  background: "transparent",
                  border: "1px solid rgba(255,255,255,0.15)",
                  color: "#888",
                  borderRadius: 30,
                  padding: "7px 16px",
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                + {hiddenCount} more outside your area
              </button>
            )}
            {showAll && (
              <button
                onClick={() => setShowAll(false)}
                style={{
                  background: "transparent",
                  border: "1px solid rgba(100,80,255,0.4)",
                  color: "#a78bfa",
                  borderRadius: 30,
                  padding: "7px 16px",
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Show local only
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: "0 40px 32px",
          display: "flex",
          gap: 24,
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 13, color: "#666" }}>
          Showing{" "}
          <strong style={{ color: "#a78bfa" }}>{filtered.length}</strong> event
          {filtered.length !== 1 ? "s" : ""}
          {userLoc && !showAll
            ? ` for ${
                [userLoc.city, userLoc.state].filter(Boolean).join(", ") ||
                "your region"
              } + Global`
            : " worldwide"}
        </span>
        {locLoading && (
          <span
            style={{
              fontSize: 12,
              color: "#555",
              animation: "pulse 1.5s infinite",
            }}
          >
            ● Fetching your location…
          </span>
        )}
      </div>

      {/* Grid */}
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: "0 40px 80px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: 24,
        }}
      >
        {filtered.length === 0 ? (
          <div
            style={{
              gridColumn: "1/-1",
              textAlign: "center",
              padding: "80px 20px",
              color: "#555",
            }}
          >
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔭</div>
            <p style={{ fontSize: 18, margin: 0 }}>
              No events found for your filters.
            </p>
            <p style={{ fontSize: 14, marginTop: 8, color: "#444" }}>
              Try changing your category or{" "}
              <span
                style={{ color: "#a78bfa", cursor: "pointer" }}
                onClick={() => setShowAll(true)}
              >
                show events outside your area
              </span>
              .
            </p>
          </div>
        ) : (
          filtered.map((event, i) => (
            <EventCard
              key={event.id}
              event={event}
              userLoc={userLoc}
              index={i}
            />
          ))
        )}
      </div>
    </div>
  );
}
